import React, { Component } from 'react'

import PropTypes from 'prop-types'

export default class Checkbox extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    checked: PropTypes.bool
  }

  render() {
    const { id, value, handleChange, children, checked, labelClass } = this.props

    return (
      <div className="checkbox_wrapper">
        <input
          type="checkbox"
          id={id}
          value={value}
          checked={checked}
          onChange={event => {
            handleChange(event)
          }}
        />
        <label htmlFor={id} className={labelClass}>
          <span />
          {children}
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/components/UI/Checkbox.jsx